import { combineEpics, ofType } from 'redux-observable';
import { Observable, of } from 'rxjs';
import { catchError, map, mergeMap, startWith } from 'rxjs/operators';
import { requestActions } from '../apiHelpers';
import { ID, ReduxAction, UserSession } from '@repo/utils/types';
import { apiObservable } from '@repo/utils/helpers/api';
import AppState from '../../reducers/app-state';

/* Epic actions */
const sharedContactHighlightsActions = requestActions('SHARED_CONTACT_HIGHLIGHTS', ['fetch']);

/* Component actions */
export const fetchSharedContactHighlights = (contactUUID: ID, user: UserSession | null) =>
  sharedContactHighlightsActions['fetch']({ contactUUID, authenticatedUser: !!user });

/* Epics */
export const fetchSharedContactHighlightsEpic = (action$: Observable<ReduxAction>) =>
  action$.pipe(
    ofType('FETCH_SHARED_CONTACT_HIGHLIGHTS'),
    mergeMap(({ payload }) =>
      apiObservable('GET', `/shared-contact/${payload.contactUUID}/highlights/`, undefined, {
        noAuthorization: !payload.authenticatedUser,
        apiVersion: 'v2',
      }).pipe(
        map(({ response }) =>
          sharedContactHighlightsActions['fetchSucceeded']({
            response,
            contactUUID: payload.contactUUID,
          }),
        ),
        startWith(
          sharedContactHighlightsActions['fetchRequested']({ contactUUID: payload.contactUUID }),
        ),
        catchError((err) =>
          of(
            sharedContactHighlightsActions['fetchFailed']({
              ...err,
              contactUUID: payload.contactUUID,
            }),
          ),
        ),
      ),
    ),
  );

export const sharedHighlightsEpic = combineEpics<ReduxAction, any, AppState>(
  fetchSharedContactHighlightsEpic,
);
